import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	forms: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.forms',
		defaultMessage: 'Forms',
		description: 'Title for the Forms settings navigation item',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.title',
		defaultMessage: 'Project settings',
		description: 'Title for project settings navigation panel',
	},
	slaSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.sla-settings',
		defaultMessage: 'SLAs',
		description: 'title for SLAs settings navigation item',
	},
	customerSatisfaction: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.customer-satisfaction',
		defaultMessage: 'Customer satisfaction',
		description: 'Customer satisfaction Settings navigation menu link for a service project',
	},
	requestTypesGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-nextgen.request-management.request-types-group',
		defaultMessage: 'Request types',
		description: 'Nav group label for request types related pages',
	},
});
